import styled from '@emotion/styled'
import { Dimension } from '@pubstack/common/src/analytics/dimension'
import { AnalyticsQueryDashboard } from '@pubstack/common/src/analytics/query'
import { useAtom } from 'jotai'
import { FunctionComponent, useState } from 'react'
import { LazyVisible } from '~/components/LazyVisible'
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs'
import { useScopeCurrency } from '~/hooks/useScopeCurrency.hooks'
import { AnalyticsPage } from '~/modules/analytics/AnalyticsPage'
import { contextState } from '~/state'
import { WithClassName } from '~/types/utils'
import { onBreakdownRowClick } from '~/utils/analytics'
import { UserSessionBreakdown } from './UserSessionBreakdown'
import { UserSessionTimeline } from './UserSessionTimeline'

const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  & > * + * {
    margin-top: 16px;
  }
`

type UserSessionPageProps = WithClassName
const BaseUserSessionPage: FunctionComponent<UserSessionPageProps> = ({ className }) => {
  const dimensions: Dimension[] = ['tagId', 'device', 'country']
  const dashboard: AnalyticsQueryDashboard = { name: 'user-session', filterType: 'auctions' }
  const currencySymbol = useScopeCurrency()
  const [context, setContext] = useAtom(contextState)

  const [breakdownDimension, setBreakdownDimension] = useState<Dimension>('tagId')

  const onBreakdownTabChange = (dimension: Dimension) => {
    setBreakdownDimension(dimension)
  }

  const loadAllData = async () => {
    setContext({ ...context })
  }

  const breadcrumbs = useBreadcrumbs()

  return (
    <AnalyticsPage title={breadcrumbs} className={className} onRefreshClick={loadAllData} filterDimensions={dimensions} dashboard={dashboard}>
      <PageContent>
        <UserSessionTimeline context={context} currencySymbol={currencySymbol} />
        <LazyVisible minHeight={400}>
          <UserSessionBreakdown
            onRowClick={onBreakdownRowClick(breakdownDimension, setContext)}
            onTabChange={onBreakdownTabChange}
            context={context}
            dimension={breakdownDimension}
            currencySymbol={currencySymbol}
          />
        </LazyVisible>
      </PageContent>
    </AnalyticsPage>
  )
}
export const UserSessionPage = styled(BaseUserSessionPage)``
